// PNG Income Tax Act 2025 — effective from 1 January 2026
export const NON_RESIDENT_BRACKETS = [
  { from: 0,      to: 20000,    rate: 0.22 },
  { from: 20000,  to: 33000,    rate: 0.30 },
  { from: 33000,  to: 70000,    rate: 0.35 },
  { from: 70000,  to: 250000,   rate: 0.40 },
  { from: 250000, to: Infinity, rate: 0.42 },
];
export const RESIDENT_BRACKETS = [
  { from: 0,      to: 20000,    rate: 0.00 },
  { from: 20000,  to: 33000,    rate: 0.30 },
  { from: 33000,  to: 70000,    rate: 0.35 },
  { from: 70000,  to: 250000,   rate: 0.40 },
  { from: 250000, to: Infinity, rate: 0.42 },
];

// Normalize legacy empType values — only "non-resident" is non-resident, everything else defaults to resident
export function normalizeResidency(type) {
  if (type === "non-resident") return "non-resident";
  return "resident";
}

export function computeAnnualTax(annualGross, residency, dependants = 0) {
  const r = normalizeResidency(residency);
  const deps = Math.min(parseInt(dependants || 0), 3);
  // K200/yr deduction for anyone with dependants
  const deduction = deps > 0 ? 200 : 0;
  const taxable = Math.max(0, annualGross - deduction);
  const brackets = r === "resident" ? RESIDENT_BRACKETS : NON_RESIDENT_BRACKETS;
  let tax = 0;
  for (const b of brackets) {
    if (taxable <= b.from) break;
    tax += (Math.min(taxable, b.to) - b.from) * b.rate;
  }
  // Dependent rebate per IRC Form I: K450 (1st) + K300 (2nd) + K300 (3rd), max 3, cap K1,050
  const rebate = r === "resident" ? (deps >= 1 ? 450 : 0) + (deps >= 2 ? 300 : 0) + (deps >= 3 ? 300 : 0) : 0;
  const finalTax = Math.max(0, tax - rebate);
  return { finalTax, rebate, effectiveRate: annualGross > 0 ? finalTax / annualGross : 0 };
}

export function netToGross(annualNet, type, dependants = 0) {
  let lo = annualNet, hi = annualNet * 4;
  for (let i = 0; i < 120; i++) {
    const mid = (lo + hi) / 2;
    const { finalTax } = computeAnnualTax(mid, type, dependants);
    const diff = (mid - finalTax) - annualNet;
    if (Math.abs(diff) < 0.01) { lo = hi = mid; break; }
    if (diff < 0) lo = mid; else hi = mid;
  }
  return (lo + hi) / 2;
}

export function calcMonth(rateLines, allowances, residency, dependants) {
  const valid = rateLines.filter(l => parseFloat(l.rate) > 0 && (l.rateMode === "monthly" || parseFloat(l.days) > 0));
  if (!valid.length) return null;
  const totalNet = valid.reduce((s, l) => s + (l.rateMode === "monthly" ? parseFloat(l.rate) : parseFloat(l.days) * parseFloat(l.rate)), 0);
  const totalDays = valid.reduce((s, l) => s + (l.rateMode === "monthly" ? 0 : parseFloat(l.days)), 0);
  const totalAllowances = allowances.reduce((s, a) => {
    const amt = parseFloat(a.amount) || 0;
    return s + (a.type === "per_diem" ? amt * totalDays : amt);
  }, 0);

  // Annualise: monthly net × 12 (standard PNG payroll method)
  const annualNet = totalNet * 12;
  const norm = normalizeResidency(residency);
  const annualGross = netToGross(annualNet, norm, dependants);
  const { finalTax, rebate, effectiveRate } = computeAnnualTax(annualGross, norm, dependants);
  return {
    totalNet, totalDays, totalAllowances,
    annualGross, annualTax: finalTax, rebate,
    monthlyGross: annualGross / 12,
    monthlyTax: finalTax / 12,
    effectiveRate,
  };
}
